// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calc-row, .calc-column {
    display: flex;
    gap: 20px;
    background: #fff;
    width: 100%;
    flex-wrap: wrap;
}

.calc-column {
    width: 410px;
    flex-direction: column;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    padding-bottom: 35px;
}

.no-check {
    padding-top: 35px;
}

.justzero-checkbox {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 8px;
    background: #f7f7f7;
    padding: 15px 35px;
    border-radius: 16px 16px 0 0;
    margin: 0;
}

.justzero-checkbox.step {
    background: transparent;
    padding: 0;
    border-radius: 0;
}

.justzero-label {
    font-weight: bold;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 20px;
}

.step .justzero-label {
    align-items: end;
    gap: 10px;
}

.justzero-label p {
    font-weight: 500;
    font-size: 13px;
    margin: 0;
}

.calc {
    padding-inline: 35px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.calc article {
    font-size: 16px;
    font-weight: 600;
}

.calc section {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.calc section p {
    font-size: 12px;
}

#justzero {
    display: none;
}

.justzero-label .checkbox {
    width: 20px;
    height: 20px;
    background-color: #fff;
    border: 2px solid var(--color-gray1);
    border-radius: 4px;
    cursor: pointer;
    transition: 0.1s;
    position: relative;
    margin: 0;
}

.step .justzero-label .checkbox {
    border: 2px solid #B8BEC0;
}

.justzero-label .checkbox.on {
    border-color: var(--color-gray1);
    background-color:var(--color-gray1);
}

.circled {
    border-radius: 100% !important;
}

.checkbox.circled {
    width: 24px;
    height: 24px;
}

.checkmark {
    transition: 0.1s;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
}

.skeletonbox {
    border-radius: 16px;
}

.advantages {
    padding: 24px 0 24px 0;
    background-color: #F0F3F7;
    border-radius: 8px;
}

.advantages-list {
    display: flex;
    flex-wrap: wrap;
}
.advantages-item {
    flex: 1 1 300px;
    position: relative;
    font-size: 14px;
    line-height: 120%;
    padding-left: 16px;
    margin-left: 16px;
}
.advantages-item::before {
    content: '';
    position: absolute;
    top: 4px; 
    left: 0px; 
    width: 8px;
    height: 8px;
    background-color: #005c32;
    border-radius: 50%; 
}

.blur {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.calculator-block {
    padding-top: 20px;
    padding-bottom: 20px;
    user-select: none;
}

.calculator-block article, .calculator-block button, .calculator-block label, .calculator-block p {
    border: none;
    margin: 0;
}

.link-row {
    display: flex;
    flex-direction: row;
    align-items: end;
    line-height: 14px;
    font-size: 12px;
    gap: 4px;
}

.link-row a {
    color: #005c32;
    text-decoration: underline 1px solid #005c32;
    font-weight: 700;
}

.calc-step-form{
    display: flex;
    flex-direction: column;
    padding: 35px;
    border: 1px solid #D9DADA;
    border-radius: 16px;
    gap: 16px;
}

.calc-step-form .tab-icon{
    height: 23px;
    width: auto;
    vertical-align: middle;
}

.calc-article {
    font-size: 18px;
    font-weight: 500;
}

.infoblock-column {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 380px;
}

.calc-infoblock {
    display: flex;
    justify-content: space-between;
    align-items: end;
}

.calc-link {
    all: unset;
    cursor: pointer;
    font-size: 14px;
    color: var(--color-green);
    text-decoration: underline 1px var(--color-green);
}

.calc-text {
    font-size: 16px;
    font-weight: 400;
}

.additional-services {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
}

.tabs-row {
    display: flex;
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    background: #f0f0f0;
    transition: ease-in-out 0.25s;
}

.tab-button {
    padding: 16px 16px;
    transition: ease-in-out 0.25s;
    font-size: 18px;
    width: 100%;
    background: transparent;
    border-radius: 16px;
}

.tabs-row:has(.tab-button:hover) {
    background: #e2e2e2;
}

.tabs-row:has(.tab-button.selected:hover) {
    background: #f0f0f0;
}

.tab-button.selected {
    background: #005c32;
    color: white;
}

.tab-button.selected:hover {
    background: #005c32;
    opacity: 90%;
}

.slider-selector-row {
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: space-evenly;
}

.buttons-next {
    display: flex;
    gap: 16px;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

.public-sliders {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 8px;
}

.calc-error {
    min-width: 410px;
    height: 360px;
    border-radius: 16px;
    border: 1px solid #D9DADA;
    display: flex;
    justify-content: center;
    align-items: center; 
    padding: 16px;
    flex-direction: column;
    gap: 16px;
    text-align: center;
}

.calc-error article {
    font-size: 18px;
    font-weight: 500;
}

.calc-error p {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
}

.calc-error p a {
    margin-left: 4px;
}

.payments-sale {
    background: #9AC9A2;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    width: fit-content;
}

.mt-1 {
    margin-top: 1rem !important;
}

@media screen and (max-width: 1200px) {
    .justzero-checkbox {
        padding: 15px 20px;
    }

    .calc {
        padding-inline: 20px !important;
    }

    .calc-column {
        width: 360px;
        padding-bottom: 20px;
    }

    .calc-error {
        min-width: 360px;
    }

    .calculator-block {
        padding: 0;
        padding-top: 35px;
        padding-bottom: 35px;
    }

    .no-check {
        padding-top: 20px;
    }
    .advantages-item {
        margin-bottom: 16px;
    }
    .advantages-item:last-child {
        margin-bottom: 0px;
    }
}

@media screen and (max-width: 768px) {
    .calc-column {
        width: 100%;
    }

    .calc-step-form{
        padding: 16px;
    }

    .calc-step-form .tab-icon{
        height: 19px;
    }

    .infoblock-column {
        width: 100%;
    }

    .advantages-list {
        flex-direction: column;
    }
    .advantages-item {
        flex: auto;
    }

    .additional-services {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .tab-button {
        padding: 16px 8px;
        font-size: 16px;
    }

    .buttons-next {
        flex-direction: column;
        margin-inline: auto;
    }

    .buttons-next button {
        min-width: 280px;
    }

    .insurance-block-row {
        gap: 8px !important;
      }
}

.insurance-block-row::-webkit-scrollbar {
  height: 0px;
  background: transparent;
}
.insurance-block-row {
  scrollbar-width: none;      /* Firefox */
  -ms-overflow-style: none;   /* IE и Edge */
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.insurance-block-row {
    display: flex;
    flex-direction: row;
    gap: 16px;
    overflow-x: auto;
    white-space: nowrap;
}
.insurance-block-row > * {
    flex: 0 0 auto;
}

.calc-step-form > .insurance-block-row {
    width: 100% !important;
    max-width: 100vw;
    align-self: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,iDAAiD;AACrD;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;MACrB;AACN;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,qBAAqB,OAAO,YAAY;EACxC,wBAAwB,IAAI,cAAc;AAC5C;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;AAC1B","sourcesContent":[".calc-row, .calc-column {\n    display: flex;\n    gap: 20px;\n    background: #fff;\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n.calc-column {\n    width: 410px;\n    flex-direction: column;\n    background: #fff;\n    border-radius: 16px;\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    padding-bottom: 35px;\n}\n\n.no-check {\n    padding-top: 35px;\n}\n\n.justzero-checkbox {\n    width: 100%;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 8px;\n    background: #f7f7f7;\n    padding: 15px 35px;\n    border-radius: 16px 16px 0 0;\n    margin: 0;\n}\n\n.justzero-checkbox.step {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n}\n\n.justzero-label {\n    font-weight: bold;\n    font-size: 18px;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.step .justzero-label {\n    align-items: end;\n    gap: 10px;\n}\n\n.justzero-label p {\n    font-weight: 500;\n    font-size: 13px;\n    margin: 0;\n}\n\n.calc {\n    padding-inline: 35px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.calc article {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.calc section {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.calc section p {\n    font-size: 12px;\n}\n\n#justzero {\n    display: none;\n}\n\n.justzero-label .checkbox {\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    border: 2px solid var(--color-gray1);\n    border-radius: 4px;\n    cursor: pointer;\n    transition: 0.1s;\n    position: relative;\n    margin: 0;\n}\n\n.step .justzero-label .checkbox {\n    border: 2px solid #B8BEC0;\n}\n\n.justzero-label .checkbox.on {\n    border-color: var(--color-gray1);\n    background-color:var(--color-gray1);\n}\n\n.circled {\n    border-radius: 100% !important;\n}\n\n.checkbox.circled {\n    width: 24px;\n    height: 24px;\n}\n\n.checkmark {\n    transition: 0.1s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 20px;\n    width: 20px;\n}\n\n.skeletonbox {\n    border-radius: 16px;\n}\n\n.advantages {\n    padding: 24px 0 24px 0;\n    background-color: #F0F3F7;\n    border-radius: 8px;\n}\n\n.advantages-list {\n    display: flex;\n    flex-wrap: wrap;\n}\n.advantages-item {\n    flex: 1 1 300px;\n    position: relative;\n    font-size: 14px;\n    line-height: 120%;\n    padding-left: 16px;\n    margin-left: 16px;\n}\n.advantages-item::before {\n    content: '';\n    position: absolute;\n    top: 4px; \n    left: 0px; \n    width: 8px;\n    height: 8px;\n    background-color: #005c32;\n    border-radius: 50%; \n}\n\n.blur {\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n}\n\n.calculator-block {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    user-select: none;\n}\n\n.calculator-block article, .calculator-block button, .calculator-block label, .calculator-block p {\n    border: none;\n    margin: 0;\n}\n\n.link-row {\n    display: flex;\n    flex-direction: row;\n    align-items: end;\n    line-height: 14px;\n    font-size: 12px;\n    gap: 4px;\n}\n\n.link-row a {\n    color: #005c32;\n    text-decoration: underline 1px solid #005c32;\n    font-weight: 700;\n}\n\n.calc-step-form{\n    display: flex;\n    flex-direction: column;\n    padding: 35px;\n    border: 1px solid #D9DADA;\n    border-radius: 16px;\n    gap: 16px;\n}\n\n.calc-step-form .tab-icon{\n    height: 23px;\n    width: auto;\n    vertical-align: middle;\n}\n\n.calc-article {\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.infoblock-column {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 380px;\n}\n\n.calc-infoblock {\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n}\n\n.calc-link {\n    all: unset;\n    cursor: pointer;\n    font-size: 14px;\n    color: var(--color-green);\n    text-decoration: underline 1px var(--color-green);\n}\n\n.calc-text {\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.additional-services {\n    display: flex;\n    gap: 24px;\n    flex-wrap: wrap;\n}\n\n.tabs-row {\n    display: flex;\n    width: 100%;\n    border-radius: 16px;\n    overflow: hidden;\n    background: #f0f0f0;\n    transition: ease-in-out 0.25s;\n}\n\n.tab-button {\n    padding: 16px 16px;\n    transition: ease-in-out 0.25s;\n    font-size: 18px;\n    width: 100%;\n    background: transparent;\n    border-radius: 16px;\n}\n\n.tabs-row:has(.tab-button:hover) {\n    background: #e2e2e2;\n}\n\n.tabs-row:has(.tab-button.selected:hover) {\n    background: #f0f0f0;\n}\n\n.tab-button.selected {\n    background: #005c32;\n    color: white;\n}\n\n.tab-button.selected:hover {\n    background: #005c32;\n    opacity: 90%;\n}\n\n.slider-selector-row {\n    display: flex;\n    gap: 10px;\n    width: 100%;\n    justify-content: space-evenly;\n}\n\n.buttons-next {\n    display: flex;\n    gap: 16px;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.public-sliders {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-bottom: 8px;\n}\n\n.calc-error {\n    min-width: 410px;\n    height: 360px;\n    border-radius: 16px;\n    border: 1px solid #D9DADA;\n    display: flex;\n    justify-content: center;\n    align-items: center; \n    padding: 16px;\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n}\n\n.calc-error article {\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.calc-error p {\n    font-size: 14px;\n    font-weight: 400;\n    text-align: center;\n}\n\n.calc-error p a {\n    margin-left: 4px;\n}\n\n.payments-sale {\n    background: #9AC9A2;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: 500;\n    width: fit-content;\n}\n\n.mt-1 {\n    margin-top: 1rem !important;\n}\n\n@media screen and (max-width: 1200px) {\n    .justzero-checkbox {\n        padding: 15px 20px;\n    }\n\n    .calc {\n        padding-inline: 20px !important;\n    }\n\n    .calc-column {\n        width: 360px;\n        padding-bottom: 20px;\n    }\n\n    .calc-error {\n        min-width: 360px;\n    }\n\n    .calculator-block {\n        padding: 0;\n        padding-top: 35px;\n        padding-bottom: 35px;\n    }\n\n    .no-check {\n        padding-top: 20px;\n    }\n    .advantages-item {\n        margin-bottom: 16px;\n    }\n    .advantages-item:last-child {\n        margin-bottom: 0px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .calc-column {\n        width: 100%;\n    }\n\n    .calc-step-form{\n        padding: 16px;\n    }\n\n    .calc-step-form .tab-icon{\n        height: 19px;\n    }\n\n    .infoblock-column {\n        width: 100%;\n    }\n\n    .advantages-list {\n        flex-direction: column;\n    }\n    .advantages-item {\n        flex: auto;\n    }\n\n    .additional-services {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .tab-button {\n        padding: 16px 8px;\n        font-size: 16px;\n    }\n\n    .buttons-next {\n        flex-direction: column;\n        margin-inline: auto;\n    }\n\n    .buttons-next button {\n        min-width: 280px;\n    }\n\n    .insurance-block-row {\n        gap: 8px !important;\n      }\n}\n\n.insurance-block-row::-webkit-scrollbar {\n  height: 0px;\n  background: transparent;\n}\n.insurance-block-row {\n  scrollbar-width: none;      /* Firefox */\n  -ms-overflow-style: none;   /* IE и Edge */\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.insurance-block-row {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    overflow-x: auto;\n    white-space: nowrap;\n}\n.insurance-block-row > * {\n    flex: 0 0 auto;\n}\n\n.calc-step-form > .insurance-block-row {\n    width: 100% !important;\n    max-width: 100vw;\n    align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
